import { Injectable } from '@angular/core';
import { Device, DeviceId, DeviceInfo } from '@capacitor/device';

@Injectable({
  providedIn: 'root'
})
export class DeviceWrapper {
  async getDeviceInfo(): Promise<DeviceInfo> {
    const deviceInfo = await Device.getInfo();
    return deviceInfo;
  }

  async getDeviceId(): Promise<DeviceId> {
    const deviceId = await Device.getId();
    return deviceId;
  }
}
